var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg3678096787a)" },
      React.createElement("path", { d: "M43.714 42.857a4.102 4.102 0 0 0 2.809-1.06l-13.6-13.6-.94.678a62.733 62.733 0 0 1-2.479 1.754c-.634.42-1.478.848-2.53 1.286-1.055.438-2.037.656-2.948.656h-.053c-.91 0-1.893-.218-2.947-.656-1.053-.438-1.897-.866-2.53-1.286a63.154 63.154 0 0 1-2.479-1.754c-.284-.208-.598-.437-.938-.68L1.477 41.796a4.103 4.103 0 0 0 2.809 1.06h39.428zM2.706 19.634A14.197 14.197 0 0 1 0 17.304v20.69l11.986-11.986a926.727 926.727 0 0 0-9.28-6.374zM45.322 19.634a788.097 788.097 0 0 0-9.303 6.379L48 37.995V17.303a14.785 14.785 0 0 1-2.678 2.331z" }),
      React.createElement("path", { d: "M43.714 5.143H4.286c-1.376 0-2.433.464-3.174 1.392-.741.929-1.111 2.09-1.111 3.482 0 1.125.49 2.344 1.473 3.657.981 1.313 2.026 2.343 3.133 3.093.607.43 2.438 1.702 5.492 3.817a1737.633 1737.633 0 0 1 7.017 4.89l.4.284.74.532c.58.42 1.061.76 1.445 1.018.384.26.848.55 1.393.87a8.122 8.122 0 0 0 1.54.724c.483.16.93.241 1.34.241h.053c.41 0 .857-.08 1.34-.241.482-.16.995-.402 1.54-.723a28.475 28.475 0 0 0 1.393-.87c.384-.26.866-.599 1.446-1.019a176.562 176.562 0 0 1 1.139-.817 25292.38 25292.38 0 0 1 12.536-8.706 12.74 12.74 0 0 0 3.267-3.294C47.562 12.188 48 10.839 48 9.429c0-1.179-.425-2.188-1.272-3.028-.849-.839-1.853-1.258-3.014-1.258z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg3678096787a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h48v48H0z" })
      )
    )
  );
});